import { useId } from "react";
import { FONT_DISPLAY } from "../../lib/tokens";

export function ScrollyLogo({
  isDark,
  size = 1,
}: {
  isDark: boolean;
  size?: number;
}) {
  // useId: SSR/Client-konsistent, eindeutig pro Instanz. Verhindert
  // Gradient-Kollisionen wenn mehrere Logos im DOM rendern (Safari/Firefox).
  const rawId = useId();
  const gradientId = `scrolly-logo-grad-${rawId.replace(/:/g, "")}`;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 7,
        padding: `${6 * size}px 0`,
      }}
    >
      <svg
        width={22 * size}
        height={22 * size}
        viewBox="0 0 22 22"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#FF3366" />
            <stop offset="1" stopColor="#6366F1" />
          </linearGradient>
        </defs>
        <path
          d="m11 1 2.8 6.3L20.5 8l-5 4.5 1.3 6.8L11 16.1 5.2 19.3 6.5 12.5 1.5 8l6.7-.7z"
          fill={`url(#${gradientId})`}
        />
      </svg>
      <span
        style={{
          fontFamily: FONT_DISPLAY,
          fontSize: 24 * size,
          fontWeight: 500,
          letterSpacing: -0.3,
          color: isDark ? "#fff" : "#111",
        }}
      >
        scrolly
      </span>
    </div>
  );
}
